export const NULL_STATE_METRIC_PLACEHOLDER = "- -";
